module.exports = __webpack_public_path__ + "talk.png?6b6a05eb6d517c9e8c1aabf47128a909";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/talk.png
// module id = 324
// module chunks = 0